<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar
          :room="true"
          @finishSession="endCall"
        />
      </div>
      <div class="flex-fill overflow-auto">
        <div
          v-if="ending.state"
          class="fill-height px-5"
        >
          <Loading :message="$t('session.leaving')"/>
        </div>
        <div
          v-else-if="session && session.currentState === 'connecting'"
          class="fill-height px-5"
        >
          <Loading :message="$t('session.gettingIn')"/>
        </div>
        <div
          class="fill-height text-center d-flex align-center justify-center px-5"
          v-else-if="session && session.currentState === 'disconnected'"
        >
          <div>
            <Icon
              :width="40"
              :height="40"
              class="mb-3"
              :color="'rgba(0,0,0,.54)'"
              :icon="'access-point-network-off'"
            />
            <div class="mb-5">
              {{ $t('session.connectionLost') }}
            </div>
            <v-btn
              :color="btnPrimaryConfig.data.btn"
              :style="`color: ${btnPrimaryConfig.data.text}`"
              @click="$widget.reTry()"
            >
              {{ $t('session.goBack') }}
            </v-btn>
          </div>
        </div>

        <div
          class="d-flex flex-column"
          :class="session && session.currentState === 'connected' ? 'fill-height' : 'hidden'"
        >
          <div
            v-if="['video', 'voice'].includes(channel)"
            id="videos"
            @click="toggleChatContainer(false)"
          >
            <div
              id="publisher"
              :class="[ (publisher.stream && publisher.created ? 'show' : ''), publisherVideo.position ]"
              :style="{
                transform: `rotate(${publisherVideo.rotation}deg)`,
                width: `${publisherVideo.width}px`,
                height: `${publisherVideo.height}px`
              }"
            ></div>
            <SubscriberInfo
              id="subscriber-info"
              v-if="(session && session.currentState === 'connected') && streams.list.length"
            />
            <div
              v-for="stream in streams.list.filter((stream) => streams.active === stream.name)"
              :key="`call-stream-${stream.streamId}`"
              id="subscriber"
            >
              <Subscriber
                class="subscriber-cont"
                :class="subscriberFullVideo ? 'video-contain' : ''"
                :id="stream.name"
                :stream="stream"
                :session="session"
                :options="streams.options"
                @error="handlerError"
                ref="subscriber"
              />
            </div>

            <div
              v-if="(session && session.currentState === 'connected') && !streams.list.length"
              class="fill-height d-flex align-center justify-center pa-4"
            >
              <Empty
                v-if="emptySessionConfig.data"
                icon="tooltip-account"
                :title="emptySessionConfig.data.title"
                :description="emptySessionConfig.data.description"
              />
            </div>

            <div
              class="video-overlay-opacity"
              :class="(session.currentState === 'connected') && $organization.enableWidgeBlur() ? 'show' : 'hidden'"
              id="video-overlay-opacity"
            ></div>

            <div v-if="streams.list.length > 1 && !$organization.totemMode().isActive" class="d-flex align-items-center justify-content-center streams-selector">
              <v-btn
                small
                elevation="0"
                fab
                :color="(stream.name === streams.active) ? 'primary' : ''"
                v-for="stream in streams.list"
                :key="`stream-${stream.streamId}`"
                @click="changeStream(stream.name)"
                :id="stream.name"
                :class="`stream left-button-float-${stream.name}`"
              >
                <Icon
                  :size="20"
                  :color="(stream.name === streams.active) ? 'white' : '#666'"
                  :icon="`${ stream.name === 'p-screen' ? 'monitor' : 'video' }`"
                />
              </v-btn>
            </div>

            <PublisherScreen
              id="publisher-screen"
              ref="publisher-screen"
              v-if="session && session.currentState === 'connected'"
              :session="session"
            />

            <Notifications
              ref="notifications"
              v-if="session && session.currentState === 'connected'"
              :mediaAccess="publisher.mediaAccess"
              :unableToPublish="publisher.unableToPublish"
            />
          </div>
          <div
            id="chat-mode"
            v-else-if="['chat'].includes(channel) && session && session.currentState === 'connected'"
          >
            <Chat
              ref="chat"
              :session="session"
              :show="true"
            />
          </div>
          <div
            v-if="!$organization.totemMode().isActive"
            style="z-index: 99 !important"
          >
            <div
              v-if="session && session.currentState === 'connected'"
              id="actions-container"
            >
              <VideoFilters
                v-if="videoFilters.show"
                :videoProcessor="videoProcessor"
                @close="toggleVideoFilters()"
              />
              <Options
                ref="options"
                :publisherCreated="publisher.created"
                @publishScreen="publishScreen"
                @cycleVideo="cycleVideo"
                @toggleRecommendation="toggleRecommendationContainer"
                @toggleChat="toggleChatContainer"
                @toggleFilters="toggleVideoFilters"
                @publishAudio="publishAudio"
                @publishVideo="publishVideo"
                @finishSession="endCall"
              />
            </div>
          </div>
          <div
            id="ocular-chat-container"
            v-if="session && session.currentState === 'connected' && !$organization.totemMode().isActive && ['video', 'voice'].includes(channel)"
          >
            <Chat
              ref="chat"
              :session="session"
              :show="chat.show"
            />
          </div>
          <div
            id="ocular-recommendation-container"
            v-if="session && session.currentState === 'connected' && !$organization.totemMode().isActive"
          >
            <!-- <Recommendation
              ref="recommendation"
              :session="session"
              :show="recommendation.show"
              @toggleRecommendation="toggleRecommendationContainer"
            /> -->
          </div>
          <div
            id="web-key-validation"
            v-if="customerVerificationWebKey.isActive && sessionId && session.currentState === 'connected'"
          >
            <WebKeyForm v-model="webKeyFormShow" :sessionId="sessionId" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapState } from 'vuex'

import MainService from '@/services/MainService'
// import StreamHealth from '@/plugins/StreamHealth'
import ConnectionQuality from '@/plugins/ConnectionQuality'
import { getVideoProcessor, destroyVideoProcessor } from '@/plugins/video-processor-bridge'

require('@/services/LocationTracking')
require('@/plugins/ReportError')
require('@/plugins/OT')

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Loading.vue'),
    Options: () => import(/* webpackPrefetch: true */ '@/views/session/components/Options.vue'),
    PublisherScreen: () => import(/* webpackPrefetch: true */ '@/views/session/components/PublisherScreen.vue'),
    Chat: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/Index.vue'),
    WebKeyForm: () => import(/* webpackPrefetch: true */ '@/components/elements/validation-key/WebKey.vue'),
    SubscriberInfo: () => import(/* webpackPrefetch: true */ '@/views/session/components/SubscriberInfo.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Empty.vue'),
    Notifications: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Notifications.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    Subscriber: () => import(/* webpackPrefetch: true */  '@/views/session/components/Subscriber.vue'),
    VideoFilters: () => import(/* webpackPrefetch: true */ '@/views/session/components/VideoFilters.vue')
  },
  props: {
    apiKeyVP8: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_VP8
    },
    apiKeyH264: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_H264
    }
  },
  computed: {
    ...mapState({
      channel: state => state.channel
    }),
    customerVerificationWebKey () {
      const { isActive } = this.$organization.customerVerificationWebKey()

      return {
        isActive
      }
    },
    widget () {
      return this.$store.state.widget
    },
    subscriberFullVideo () {
      return this.chat.show || this.$store.state.widget.maximized || this.recommendation.show
    },
    room () {
      return this.$store.state.storage ? this.$store.state.storage.room : null
    },
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    emptySessionConfig () {
      return this.$organization.emptySessionConfig()
    },
    configInitCall () {
      return this.$organization.configInitCall()
    },
    publisherVideo () {
      const rotation = this.configInitCall.data?.publisherVideo?.rotation ?? 0

      const config = {
        position: this.configInitCall.data?.publisherVideo?.position ?? 'bottom-right',
        width: this.configInitCall.data?.publisherVideo?.width ?? 80,
        height: this.configInitCall.data?.publisherVideo?.height ?? 100,
        rotation: [ 90, 180, 270 ].includes(rotation) ? rotation : 0,
      }

      return config
    },
    publisherAudio () {
      const config = {
        noiseSuppression: this.configInitCall.data?.publisherAudio?.noiseSuppression ?? true,
      }

      return config
    },
    sessionId () {
      return this.$store.state.storage.room?.session?.id || null 
    }
  },
  methods: {
    ...mapActions({
      setAttentionChannel: 'setAttentionChannel'
    })
  }
})
export default class Index extends Vue {
  data () {
    return {
      connectionQualityInstance: null,
      ending: {
        state: false,
        from: null
      },
      endingReason: null,
      session: {
        currentState: 'connecting'
      },
      state: null,
      publisher: {
        options: {
          publishVideo: false,
          publishAudio: false,
          noiseSuppression: true,
          insertMode: 'append',
          width: '100%',
          height: '100%',
          name: 'camera',
          style: {
            nameDisplayMode: 'off',
            buttonDisplayMode: 'off'
          }
        },
        stream: null,
        created: false,
        loading: false,
        mediaAccess: true,
        unableToPublish: false,
        connectTry: 0,
        keepCallInterval: null
      },
      streams: {
        list: [],
        active: null,
        options: {
          insertMode: 'append',
          width: '100%',
          height: '100%',
          style: {
            nameDisplayMode: 'off',
            buttonDisplayMode: 'off'
          }
        }
      },
      chat: {
        show: false,
        unreadMessages: 0
      },
      recommendation: {
        show: false,
        unreadRecommendation: 0
      },
      error: null,
      wasRated: false,
      wasBlocked: false,
      webKeyFormShow: false,
      videoProcessor: null,
      videoFilters: {
        show: false
      }
    }
  }

  mounted () {
    this.ending.state = false
    this.ending.from = null
    this.$socketEvents.connectListen()
    this.initialize()
  }

  connectionError () {
    const data = {
      session: {
        id: this.$store.state.storage.room.session.id
      },
      organization: this.$store.state.widget.data,
      detail: {
        error: this.error,
        origin: ''
      }
    }

    const error = {
      session: data.session,
      sessionId: data.session.id,
      organizationId: data.organization.organization.id,
      organizationName: data.organization.name,
      code: data.detail.error.code,
      message: data.detail.error.message,
      name: data.detail.error.name,
      stack: data.detail.error.stack
    }

    this.$reportError.report(error)
    this.$socketEvents.reportProblem(data)
  }

  connectionSuccess () {
    const data = {
      error: false,
      session: {
        id: this.$store.state.storage.room.session.id
      }
    }

    this.$socketEvents.reportProblem(data)
    this.error = null
  }

  reconnect () {
    // 1004	Authentication error
    // 1005	Invalid Session ID
    // 1006	Connect Failed
    // 1007	Connect Rejected
    // 1008	Connect Time-out
    // 1009	Security Error
    // 1010	Not Connected
    // 1011	Invalid Parameter
    // 1013	Connection Failed
    // 1014	API Response Failure
    // 1026	Terms of Service Violation: Export Compliance
    // 1500	Unable to Publish
    if (this.error.code === 1500 && (this.error.name === 'OT_USER_MEDIA_ACCESS_DENIED' || this.error.name === 'OT_HARDWARE_UNAVAILABLE')) {
      this.publisher.mediaAccess = false
      this.$store.state.widget.osMediaDevicesPermissions = this.publisher.mediaAccess
      this.publisher.created = false
    } else if (this.error.code === 1500) {
      if (this.publisher.connectTry <= 3) {
        this.addPublisher()
        this.publisher.connectTry++
      } else {
        this.publisher.unableToPublish = true
        this.publisher.created = false
      }
    }
    // 1520	Unable to Force Disconnect
    // 1530	Unable to Force Unpublish
    // 1535	Force Unpublish on Invalid Stream
    // 2000	Internal Error
    // 2010	Report Issue Failure
  }

  handlerError (error) {
    if (error) {
      console.log('handlerError', error)
      this.error = error
      this.connectionError()
      this.reconnect()
    }
  }

  async keepCall () {
    const response = {
      initialize: true
    }

    await this.getSession()

    switch (this.state) {
      case 3:
      case 5:
      case 6:
      case 7:
      case 13:
      case 14:
      case 15:
      case 18:
        response.initialize = false
        break
    }

    return response
  }

  async initialize () {
    let initialize = true

    if (!this.$route.query.fromCalling) {
      const keepCallResponse = await this.keepCall()
      initialize = keepCallResponse.initialize
    }

    if (initialize) {
      this.initializeSession()
      this.$widget.setBuyOrderSessionId()
      this.$locationTracking.trackLocation()
    } else {
      this.goToPath()
    }

    return 'Success'
  }

  stopConnectionQuality () {
    if (this.connectionQualityInstance) {
      this.connectionQualityInstance.terminate()
      this.connectionQualityInstance = null
    }
  }

  startConnectionQuality (cammer) {
    if (!this.connectionQualityInstance) {
      this.connectionQualityInstance = new ConnectionQuality(this.$listenSocket)
    }

    const isActive = this.connectionQualityInstance.isActiveForCammer(cammer)

    if (!isActive) {
      this.stopConnectionQuality()
      return
    }

    this.connectionQualityInstance.initialize()
  }

  async updateCammer () {
    const data = {
      route: `ocular/session/${this.$store.state.storage.room.session.id}/user`,
      params: {}
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          const user = res.user

          this.$widget.setSessionCammerVar(user)
          Vue.prototype.$storage.setCammer({ user })
          this.startConnectionQuality(user)
          // StreamHealth.checkUserStreamHealth(user)
        }
      })
  }

  addStream (stream) {
    this.updateCammer()
    const index = this.streams.list.indexOf(stream)
    if (index === -1) {
      this.streams.list.push(stream)
    }

    setTimeout(() => {
      this.changeStream(stream.name)
    }, 500)
  }

  removeStream (stream) {
    const index = this.streams.list.indexOf(stream)
    if (index > -1) {
      this.streams.list.splice(index, 1)
    }

    if (this.streams.list.length) {
      this.changeStream(this.streams.list[0].name)
    }
  }

  callStartSettings () {
    const configInitCall = this.configInitCall

    if (configInitCall.isActive && configInitCall.data?.fullScreen) {
      const isMobile = Vue.prototype.$widget.getDevice().mobile
      const maximizeOnMobile = isMobile && configInitCall.data.fullScreen?.mobile
      const maximizeOnDesktop = !isMobile && configInitCall.data.fullScreen?.desktop

      if (maximizeOnMobile || maximizeOnDesktop) {
        this.$widget.maximizeToggler(true)
      }
    }

    this.$widget.emitEvent('call-started')
  }

  connectedConfig () {
    this.startIntervals()

    this.$store.commit('SET_ACTIVE_CALL', true)
    this.$tabsManager.callStarted()

    const session = this.room.session
    this.$socketEvents.joinToSessionRoom(session.id)

    this.callStartSettings()

    this.$emit('setOTSession', this.session)
  }

  createPublisher () {
    const publishVideo = ['video'].includes(this.channel)
    const publishAudio = ['video', 'voice'].includes(this.channel)
    this.publisher.options.publishVideo = publishVideo && this.$store.state.storage.device.camera
    this.publisher.options.publishAudio = publishAudio &&  this.$store.state.storage.device.microphone
    this.publisher.options.noiseSuppression = this.publisherAudio.noiseSuppression
    this.publisher.mediaAccess = true
    this.$store.state.widget.osMediaDevicesPermissions = this.publisher.mediaAccess

    this.publisher.stream = OT.initPublisher('publisher', this.publisher.options, this.handlerError)

    this.publisher.stream.on({
      streamCreated: () => {
        this.publisher.created = true
        this.publisher.loading = false

        this.attachVideoProcessor()
      },
      streamDestroyed: () => {
        this.publisher.created = false
        this.publisher.loading = false
      }
    })
  }

  async attachVideoProcessor () {
    try {
      this.videoProcessor = getVideoProcessor()
      await this.videoProcessor.attach(this.publisher.stream)

      this.videoProcessor.on('error', (data) => {
        console.error('[VideoProcessor]', data)
      })

      const vpConfig = this.$organization.videoProcessorConfig()
      if (vpConfig.isActive && vpConfig.data.nsfw && vpConfig.data.nsfw.autoEnable) {
        this.videoProcessor.on('nsfw:detected', (result) => {
          console.log('nsfw:detected', result)
          this.$store.commit('SET_VIDEO_PROCESSOR_NSFW_EVENT', result)

          if (result.isExplicit && this.session) {
            this.session.signal({
              type: 'nsfw',
              data: JSON.stringify({
                isExplicit: result.isExplicit,
                topPrediction: result.topPrediction,
                timestamp: result.timestamp,
                source: 'widget'
              })
            }, (error) => {
              if (error) {
                console.error('[NSFW Signal] Error:', error.message)
              }
            })

            this.videoProcessor.resetNSFWDetectionState()
          }
        })

        await this.videoProcessor.enableNSFWDetection({
          sampleIntervalMs: vpConfig.data.nsfw.sampleIntervalMs ?? 1500,
          threshold: vpConfig.data.nsfw.threshold ?? 0.75,
          model: vpConfig.data.nsfw.model ?? 'InceptionV3',
          categories: vpConfig.data.nsfw.categories ?? ['Porn', 'Hentai'],
          autoBlur: vpConfig.data.nsfw.autoBlur ?? false,
          windowSize: vpConfig.data.nsfw.windowSize ?? 5,
          minExplicitInWindow: vpConfig.data.nsfw.minExplicitInWindow ?? 3,
          cooldownMs: vpConfig.data.nsfw.cooldownMs ?? 30000
        })
        this.$store.commit('SET_VIDEO_PROCESSOR_NSFW', true)
      }
    } catch (e) {
      console.error('[VideoProcessor] Failed to attach:', e)
    }
  }

  toggleVideoFilters () {
    this.videoFilters.show = !this.videoFilters.show
  }

  addPublisher () {
    if (['chat'].includes(this.channel)){
      return false
    }

    this.publisher.created = false
    this.publisher.loading = true
    this.session.publish(this.publisher.stream, this.handlerError)
  }

  initializeSession () {
    const apiKey = this.$store.state.storage.codec === 'H264' ? this.apiKeyH264 : this.apiKeyVP8
    const sessionId = this.$store.state.storage.room.session.tokboxId
    const token = this.$store.state.storage.room.session.token

    if (!apiKey && !sessionId && !token) {
      return false
    }

    this.session = OT.initSession(apiKey, sessionId)

    if (['video', 'voice'].includes(this.channel)) {
      this.createPublisher()
    }

    this.session.connect(token, (error) => {
      if (this.widget.isBusy) {
        this.endingReason = 'isBusy'
        this.disconnectSession()
      } else if (error) {
        this.handlerError(error)
      } else {
        this.connectedConfig()
        this.addPublisher()
      }
    })

    this.session.on('streamCreated', (event) => {
      const stream = event.stream
      this.addStream(stream)
    })

    this.session.on('streamDestroyed', (event) => {
      this.removeStream(event.stream)
    })

    this.$listenSocket.on('disconnect_session', (arg) => {
      if (arg.from === 'cammer-app' && ['chat'].includes(this.channel)) {
        this.ending.state = true
        this.ending.from = 'cammer-options'
        this.endingReason = 'forceDisconnected'

        this.clearSession()
        this.session.disconnect()
        this.goToPath()
      }
    })

    this.session.on('signal:end_reason', (event) => {
      try {
        const data = JSON.parse(event.data)
        if (data.blocked) {
          this.wasBlocked = true
        }
      } catch (error) {
        console.error('[Widget] Error parsing end_reason signal:', error)
      }
    })

    this.session.on('sessionDisconnected', (event) => {
      if (this.endingReason === 'isBusy') {
        this.$widget.show(false)
        this.$router.replace({ path: '/is-busy' })
      } else if (event.reason === 'forceDisconnected') {
        this.ending.state = true
        this.ending.from = 'cammer-options'
        this.endingReason = 'forceDisconnected'

        this.clearSession()

        if (this.wasBlocked) {
          Vue.prototype.$storage.setState(1)
          this.$router.replace({ path: '/thank-you-page', query: { goodBye: true } })
        } else {
          this.goToPath()
        }
      } else if (event.reason === 'networkDisconnected') {
        // code
      } else if (event.reason === 'clientDisconnected' && this.endingReason === 'clientDisconnected') {
        this.finishSession()
      }
    })
  }

  toggleChatContainer (show) {
    document.querySelector('#ocular-recommendation-container').classList.remove('show')
    this.recommendation.show = false

    if (typeof show === 'undefined') {
      document.querySelector('#ocular-chat-container').classList.toggle('show')
    } else if (show) {
      document.querySelector('#ocular-chat-container').classList.add('show')
    } else {
      document.querySelector('#ocular-chat-container').classList.remove('show')
    }

    this.chat.show = document.querySelector('#ocular-chat-container').classList.contains('show')

    if (this.chat.show) {
      setTimeout(() => {
        const lastMessageElement = document.querySelector('#messages-container .message-container:last-child')
        if (lastMessageElement) {
          lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
        }
      }, 300)
    }

    this.chat.unreadMessages = 0
  }

  toggleRecommendationContainer (show) {
    document.querySelector('#ocular-chat-container').classList.remove('show')
    this.chat.show = false
    if (typeof show === 'undefined') {
      document.querySelector('#ocular-recommendation-container').classList.toggle('show')
    } else if (show) {
      document.querySelector('#ocular-recommendation-container').classList.add('show')
    } else {
      document.querySelector('#ocular-recommendation-container').classList.remove('show')
    }

    this.recommendation.show = document.querySelector('#ocular-recommendation-container').classList.contains('show')
    this.recommendation.unreadRecommendation = 0
  }

  changeStream (type) {
    this.streams.active = type

    const streamElements = this.$el.querySelectorAll('.streams-selector .stream')
    for (let index = 0; index < streamElements.length; index++) {
      const stream = streamElements[index]
      stream.classList.remove('active')
    }

    const activeStream = this.$el.querySelector(`.streams-selector .stream#${type}`)
    activeStream ? activeStream.classList.add('active') : false
  }

  publishAudio (publish) {
    if (this.publisher.stream) {
      this.$store.state.storage.device.microphone = publish
      Vue.prototype.$storage.updateStorageData()

      this.publisher.stream.publishAudio(publish)
    }
  }

  publishVideo (publish) {
    if (this.publisher.stream) {
      this.$store.state.storage.device.camera = publish
      Vue.prototype.$storage.updateStorageData()

      this.publisher.stream.publishVideo(publish)
    }
  }

  publishScreen () {
    if (this.$refs['publisher-screen']) {
      this.$refs['publisher-screen'].publishScreen()
    }
  }

  cycleVideo () {
    if (this.publisher.stream) {
      this.publisher.stream.cycleVideo()
    }
  }

  disconnectSession () {
    if (this.streams.list.length) {
      for (let index = 0; index < this.streams.list.length; index++) {
        const subscriber = this.streams.list[index]
        this.session.forceDisconnect(subscriber.connection, this.handlerError)
        this.streams.list.splice(index, 1)
      }
    }

    this.session.disconnect()
  }

  endCall (from) {
    this.ending.state = true
    this.ending.from = from
    this.endingReason = 'clientDisconnected'

    if (this.error && this.error.code === 1004) {
      this.clearSession()
      Vue.prototype.$storage.setState(1)
      this.$router.replace({ path: '/' })
    } else {
      this.disconnectSession()
    }
  }

  clearIntervals () {
    // StreamHealth.stopIntervalLatency()

    if (this.keepCallInterval) {
      clearInterval(this.keepCallInterval)
    }
  }

  startIntervals () {
    this.clearIntervals()

    this.keepCallInterval = setInterval(async () => {
      if (!this.streams.list.length) {
        const keepCallResponse = await this.keepCall()

        if (!keepCallResponse.initialize) {
          this.endingReason = 'sessionHasEnded'
          this.clearSession()
          this.goToPath()
        }
      }
    }, 30000)
  }

  clearSession () {
    try {
      this.$store.commit('SET_ACTIVE_CALL', false)
      this.clearIntervals()
      this.$tabsManager.callFinished()

      this.$ocularAnalitycs.widgetAnalitycsEvent({
        action: 'Finalizó la atención',
        detail: 'El cliente o el agente finalizó la atención',
        actionType: 'STAH',
        functionality: 7,
        historyInteractionType: 'OSFNSH'
      })

      this.$store.state.signal.msg = false
      this.streams.list = []

      this.$socketEvents.disconnectSession({ session: this.$store.state.storage.room.session, from: 'widget-app' })
      if (!this.$organization.totemMode().isActive) {
        this.$socketEvents.disconnectListen()
      }

      this.$widget.clearHistory()
      this.$widget.setBuyOrderSessionId(true)
      this.$widget.setSessionCammerVar(null)
      this.$widget.finishPostMessage()

      this.$widget.maximizeToggler(false)

      if (this.endingReason !== 'forceDisconnected' && this.endingReason !== 'clientDisconnected') {
        this.disconnectSession()
      }

      this.stopConnectionQuality()

      destroyVideoProcessor()
      this.videoProcessor = null
    } catch (error) {
      console.log('clearSession ERROR', error)
    }

    return 'Success'
  }

  async finishSession () {
    const data = {
      route: 'ocular/end-session',
      params: {
        session_id: this.$store.state.storage.room.session.id,
        call_register_state_id: 18,
        session_state_id: 3
      }
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          this.clearSession()

          if (this.ending.from === 'call-options') {
            this.goToPath()
          } else if (this.ending.from === 'system-bar') {
            this.$storage.initializeStorageData(true)
            this.$router.replace({ path: '/' })
          }
        }
      })
      .catch((e) => {
        this.ending.state = false
        this.ending.from = null
        console.log(e)
      })
  }

  async getSession () {
    const data = {
      route: `ocular/widget/v2/sessions/${this.$store.state.storage.room.session.id}`,
      params: {}
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          this.state = res.session.session_state_id
          this.wasRated = res.session.wasRated
          this.$storage.setStorageRoom(res.session)
          this.setAttentionChannel(res.session.channel)
        } else {
          this.$storage.setState(1)
          this.$storage.setStorageRoom(null)
          this.$widget.hide()
          this.wasRated = true
          this.goToPath()
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  goToPath () {
    if (this.$organization.totemMode().isActive) {
      Vue.prototype.$storage.setState(1)
      this.$router.replace({ path: '/totem' })
        .catch((error) => {})
    } else if (this.$organization.requireQuestion()) {
      Vue.prototype.$storage.setState(6)
      this.$router.replace({ path: '/questions' })
    } else if (!this.wasRated) {
      Vue.prototype.$storage.setState(5)
      this.$router.replace({ path: '/calification' })
    } else {
      Vue.prototype.$storage.setState(1)
      this.$router.replace({ path: '/' })
      this.$widget.hide()
    }
  }
}
</script>

<style>
.left-button-float-camera {
  z-index: 999999999999999999;
  padding: 0px;
  position: absolute;
  left: 18px;
  bottom: 15px;
}

.left-button-float-p-screen {
  z-index: 999999999999999999;
  padding: 0px;
  position: absolute;
  left: 18px;
  bottom: 65px;
}

#actions-container {
  z-index: 10;
  background: white;
  max-width: 500px;
  margin: 0 auto;
}

#actions-container.top-borders {
  border-radius: 20px !important;
}

#videos, #chat-mode {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1
}

#chat-mode {
  height: calc(100% - 46px);
}

#videos #subscriber-info {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  color: white;
}

#videos #subscriber .subscriber-cont {
/* #videos #subscriber { */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

#videos #publisher {
  position: absolute;
  width: 80px;
  height: 100px;
  bottom: 0px;
  right: 10px;
  z-index: 3;
  border: 0px solid white;
  opacity: 0;
  transition: all .3s;
}

#videos #publisher.show {
  bottom: 10px;
  opacity: 1;
}

#videos #publisher.bottom-right {
  right: 10px;
}

#videos #publisher.bottom-left {
  left: 10px;
}


#videos #publisher .OT_widget-container, #videos #publisher-screen .OT_widget-container {
  border-radius: 5px;
}

#videos #publisher video {
  border-radius: 5px;
}

#videos #publisher-screen {
  position: absolute;
  width: 150px;
  height: 100px;
  bottom: 10px;
  right: 100px;
  z-index: 3;
  border: 0px solid white;
}

#videos #publisher-screen #screen-preview {
  border-radius: 5px;
  width: 100% !important;
  height: 100% !important;
}

#videos #publisher-screen #screen-preview {
  border-radius: 5px;
  width: 100% !important;
  height: 100% !important;
}

#videos #publisher-screen video {
  border-radius: 5px;
  object-fit: contain !important;
  width: 100%;
  height: 100%;
}

#videos #options {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 100;
}

#videos .video-overlay-opacity {
  width: 100%;
  height: 100%;
  visibility: hidden;
  position: absolute;
  bottom: 0;
  z-index: 2;
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,-639) 72%, rgba(255,255,255,-6.751663) 73%,  rgba(255,255,255,-21.956145) 74%, rgba(255,255,255,1) 99%);
}

#videos .video-overlay-opacity.show {
  visibility: visible;
}

#ocular-chat-container, #ocular-recommendation-container {
  transition: all .2s;
  visibility: hidden;
  display: none;
  height: 0px !important;
}

#ocular-chat-container.show, #ocular-recommendation-container.show {
  visibility: visible;
  height: 400px !important;
  display: unset;
  max-height: calc(100% - 52px) !important;
}

.hidden {
  visibility: hidden !important;
  opacity: 0;
  height: 0 !important;
  transition: all .5s;
}

#videos #subscriber .subscriber-cont#p-screen {
  text-align: center !important;
}

#videos #subscriber .subscriber-cont video {
  width: 100% !important;
  height: 100% !important;
}

#videos #subscriber .subscriber-cont#camera.video-contain video {
  object-fit: contain;
}

#videos #subscriber .subscriber-cont#p-screen video {
  object-fit: contain;
}
</style>
